import { render, staticRenderFns } from "./GroupsWiki.vue?vue&type=template&id=9b652a1c&scoped=true&"
import script from "./GroupsWiki.vue?vue&type=script&lang=ts&"
export * from "./GroupsWiki.vue?vue&type=script&lang=ts&"
import style0 from "./GroupsWiki.vue?vue&type=style&index=0&id=9b652a1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b652a1c",
  null
  
)

export default component.exports